import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { ISendPendingAlert } from '../components/Alerts/context/alerts.interface';

export const sendPendingAlert = (payload: ISendPendingAlert) => {
    const url = `${OCTOPUS_BASE_URL}/pending-alerts`;
    const response = axios.post(url, payload);
    return response;
};
